import React from 'react'
import { ThemeProvider } from 'styled-components'
import { Themes } from '@sainsburys-tech/bolt'

const OverwriteThemeIfNeeded = ({ TEMPLATE_TYPE, children }) => {
  if (TEMPLATE_TYPE !== 'TU_ON_ARGOS') return children
  const OverwrittenTheme = {
    ...Themes.ArgosTheme,
    overwritedTheme: 'tuOnArgos',
    color_primary: Themes.TuTheme.color_primary,
    color_primary_dark: Themes.TuTheme.color_primary_dark,
    color_secondary: Themes.TuTheme.color_secondary,
    color_secondary_dark: Themes.TuTheme.color_secondary_dark
  }
  return <ThemeProvider theme={OverwrittenTheme}>{children}</ThemeProvider>
}

export default OverwriteThemeIfNeeded
